import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import API from '../services/api'

// Componentes
import Package from '../components/organisms/Package'

// moment
import 'moment/locale/pt-br'
import { getDepartmentUrl } from '../services/functions'
import { useThemes } from '../providers/theme'

moment.locale('pt-br')

const options = ['ativo', 'inativo']

function Pacotes({ location }) {
  const { theme } = useThemes();
  const [stateValue, setStateValue] = useState(0)
  const [packages, setPackages] = useState()
  const [packageSold, setPackageSold] = useState()
  const history = useHistory()
  const isClinica = location.pathname.split('/').includes('packages')

  // PAGINAÇÃO
  const date = new Date()
  const primeiroDia = moment(
    new Date(date.getFullYear(), date.getMonth(), 1),
  ).format('YYYY-MM-DD')
  const [pagination, setPagination] = useState(null)
  const [panel, setPanel] = useState(null)

  const getPackage = async (text = '') => {
    try {
      const { data } = await API.get(
        `packages/rules/search?text=${text}&department=${getDepartmentUrl()}`,
      )
      setPackages(data.results)
    } catch (err) {
      console.log('Erro:', err)
    }
  }

  const getPackageActive = async (active = true) => {
    try {
      const { data } = await API.get(
        `packages/rules/search?active=${active}&department=${getDepartmentUrl()}`,
      )
      setPackages(data.results)
    } catch (err) {
      console.log('Erro:', err)
    }
  }

  /**
   * `filtros` aceita dateFrom, dateTo, status, cpf, search, sortBy e sortOrder.
   * Status, CPF e busca sao resolvidos no servidor, e o painel vem calculado
   * sobre o conjunto filtrado inteiro, nao sobre a pagina.
   */
  const getPackageSold = async (currentePage = 1, filtros = {}) => {
    try {
      const params = new URLSearchParams()
      params.set('dateFrom', filtros.dateFrom || primeiroDia)
      params.set('dateTo', filtros.dateTo || moment(date).format('YYYY-MM-DD'))
      params.set('currentePage', currentePage)
      params.set('perPage', 50)
      params.set('department', getDepartmentUrl())

      if (filtros.status && filtros.status !== '*') params.set('status', filtros.status)
      if (filtros.cpf) params.set('cpf', filtros.cpf)
      if (filtros.search) params.set('search', filtros.search)
      if (filtros.sortBy) {
        params.set('sortBy', filtros.sortBy)
        params.set('sortOrder', filtros.sortOrder || 'desc')
      }

      const { data } = await API.get(`packages/orders?${params.toString()}`)

      setPackageSold(data.results)
      setPagination(data?.pagination)
      setPanel(data?.panel || null)
    } catch (err) {
      console.log('Erro:', err)
    }
  }

  useEffect(() => {
    setPackages([])
    getPackage()
    getPackageSold()
  }, [theme])

  return (
    <>
      {stateValue === 0 && (
        <Package
          packages={packages}
          packageSold={packageSold}
          getPackageSold={getPackageSold}
          options={options}
          date={date}
          primeiroDia={primeiroDia}
          stateValue={setStateValue}
          getPackage={getPackage}
          pagination={pagination}
          panel={panel}
          setPackageSold={setPackageSold}
          getPackageActive={getPackageActive}
        />
      )}
      {stateValue === 1 && history.push(`/pacotes/new?clinica=${isClinica}`)}
    </>
  )
}

export default Pacotes
